<template>
        <v-row class="mb-2">
            <v-col cols="8">
            <h2 class="title">{{ title | translate }}</h2>
            <span v-if="subtitle != undefined && subtitle.length > 0" class="subtitle">{{ subtitle | translate }}</span>
            </v-col>
            <v-col cols="4" class="d-flex justify-end">
    
            <v-spacer></v-spacer>
            <v-btn small :color="primary_color" class="white--text" @click="showVideoTutorial=!showVideoTutorial">{{ 'Video' | translate }}</v-btn>
            </v-col>
            <v-dialog v-model="showVideoTutorial" max-width="800" :key="$route.name+''+showVideoTutorial">
            <v-card>
                    <v-card-title>
                    <span class="headline">{{ 'Tutorial'| translate }}</span>
                    </v-card-title>
                <v-row>
                    <v-col cols="12">
                        <div class="iframe-container" style="overflow: hidden; padding-top: 47.00%; position: relative;">
                            <iframe id="iframemodule" :src="videotutorialdata[$route.name]" style="border: 0;height: 100%;left: 0; position: absolute; top: 0; width: 100%;" allowfullscreen></iframe>
                        </div>
                    </v-col>
                </v-row>
                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary darken-1" text @click="showVideoTutorial = false">{{ 'Close'| translate }}</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
            <v-col cols="12" class="mt-n2">
                <v-divider></v-divider>
            </v-col>
        </v-row>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "Header",
    props:{
        title: String,
        subtitle: String,
    },
    computed: {
        ...mapGetters(['videotutorialdata',"currentUser"]),
    },
    created(){
        let company_meta  = JSON.parse(this.currentUser.company.company_meta)
        this.primary_color  = company_meta.primary_color
    },
    data: function() {
        return {
            showVideoTutorial: false,
            primary_color: '',
            tutorDialog: false,
        }
    }
}
</script>
<style scoped>
.title{
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
    font-size: 1.4rem !important;
    font-weight: 500 !important;
    letter-spacing: 0.0125em !important;
    line-height: 2rem !important;
    word-break: break-all !important;
    padding-bottom: 5px !important;
}

.subtitle{
    font-size: 0.875rem !important;
    font-weight: 400 !important;
    line-height: 1.375rem !important;
    letter-spacing: 0.0071428571em !important;
    color: rgba(0, 0, 0, 0.6) !important;
}
</style>